<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Abendstimmung</h3>
<p class="vers">Hin durch den Forst schießt eine weiße
Schlange,<br class="calibre2"/>
spitz ist ihr Haupt, ihr Schweif verweht im Winde;<br class="calibre2"/>
darunter braust auf stählernem Gewinde<br class="calibre2"/>
der Erdenpuls in nimmermüdem Gange.</p>
<p class="vers">Verschwunden ist sie tief im Forste lange,<br class="calibre2"/>
stumm ragt die Kiefer, um die rote Rinde<br class="calibre2"/>
spielt schon der Nachthauch, schweifen Nebel linde,<br class="calibre2"/>
und Uhuschrei tönt ferneher und bange.</p>
<p class="vers">Ein Tümpel liegt in weltvergeßnen Träumen,<br class="calibre2"/>
vom Frühlingsregen angefüllt, am Raine;<br class="calibre2"/>
es spiegeln drin sich einsam Ost und Westen.</p>
<p class="vers">Tiefblau der Ost steht über schwarzen Bäumen,<br class="calibre2"/>
die Stirn geziert mit einem Demantsteine;<br class="calibre2"/>
der Westen prahlt mit fahlen Sonnenresten. <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page31" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0016.vue?b4b53ac4